import * as models from 'smg/models';
import * as models2 from 'smg/customer-api/models';
import { RemToPx } from 'smg/rem';
import * as column from 'smg/table/column';
import * as tableLib from 'smg/table/table';
import { DollarFormat } from 'smg/util';
import { AccountReady } from '../account-session';
import * as payments from '../payments';
import * as search from '../search';

declare interface resp {
    orderPayments: models.OrderPayment[];

    paymentOptionTypes: models.PaymentOptionType[];
}

void main();

async function main() {
    if (await AccountReady) {
        return;
    }

    type r = models.OrderPayment;
    type c = keyof r;
    type d = 'paymentOptionTypes';

    const paymentOptionTypes: Record<string, models.PaymentOptionType> = {};

    class Table extends tableLib.Table<r, c, d> {
        rowHeight = RemToPx(parseFloat(getComputedStyle(document.querySelector('.iap-table') as HTMLElement).getPropertyValue('--row-height'))) + 1;

        rowsPerPage = 100;

        getRowsFromResponse = (d: unknown) => {
            const data = d as resp;

            tableLib.Table.map(paymentOptionTypes, data.paymentOptionTypes);
            return data.orderPayments;
        };

        constructor() {
            super('/order-payments', (search.Input as HTMLInputElement), (search.Form as HTMLFormElement));

            this.addColumns(
                new column.ColumnID(),
                new column.Column({
                    name: 'Payment Method',
                    width: 10,
                    columns: ['paymentOption', 'checkNumber', 'purchaseOrderNumber'],
                    draw: async (td, r) => {
                        if (!r.paymentOption) {
                            return;
                        }

                        td.appendChild(await payments.DrawPaymentOption(models2.PaymentOption.fromJSON(r.paymentOption), models2.OrderPayment.fromJSON(r)));
                    },
                }),
                new column.Column({
                    name: 'Orders',
                    width: 10,
                    columns: 'orderPayments',
                    draw: (td, r) => {
                        if (!r.orderPayments?.length) {
                            return;
                        }

                        td.classList.add('d-flex', 'flex-direction-column');

                        let i = 0;
                        for (const orderPayment of r.orderPayments) {
                            const order = orderPayment.order;
                            if (!(order?.invoiceNumber && orderPayment.total)) {
                                continue;
                            }

                            if (i++) {
                                td.appendChild(document.createTextNode(', '));
                            }

                            const a = document.createElement('a');
                            a.textContent = `#${order.invoiceNumber} - ${DollarFormat(orderPayment.total, false, true)}`;
                            a.href = `/orders/?q=${order.invoiceNumber}`;

                            td.appendChild(a);
                        }
                    },
                }),
                new column.ColumnNumber({
                    name: 'Total',
                    width: '12rem',
                    column: 'total',
                    dollarFormat: true,
                }),
                new column.ColumnDateTime({
                    name: 'Date',
                    width: '7rem',
                    sortDirection: 'desc',
                }),
            );

            this.enableAutoUpdating(10 * 60 * 1000);
        }
    }

    const t = new Table();

    t.query.setDefaultQuery('has:total');

    void t.build();
}